
<ng-template #template>
  <div [class]="model.css" [style]="model.style">
    <div class="sv-header__cell-content" [style]="model.contentStyle">
      <div *ngIf="model.showLogo" class="sv-header__logo">
        <div [class]="model.survey.logoClassNames">
          <ng-template [component]="{ name: model.survey.getElementWrapperComponentName(model.survey, 'logo-image'), data: { data: model.survey.getElementWrapperComponentData(model.survey, 'logo-image') } }"></ng-template>
        </div>
      </div>
      <div *ngIf="model.showTitle" class="sv-header__title" [style]="{ maxWidth: model.textAreaWidth }">
        <sv-ng-element-title [element]="model.survey"></sv-ng-element-title>
      </div>
      <div *ngIf="model.showDescription" class="sv-header__description" [style]="{ maxWidth: model.textAreaWidth }">
        <div *ngIf="model.survey.renderedHasDescription" [class]="model.survey.css.description" [model]="model.survey.locDescription" sv-ng-string></div>
      </div>
    </div>
  </div>
</ng-template>